module.exports = __webpack_public_path__ + "static/media/tckgraphic.656332e1.png";